import React from "react";
import '../assets/styles/notfound.css'

export default function NotFound(){
    return(
        <div className="not-found-component">

        </div>
    )
}